import { z } from "zod";

const addChildrenSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(50, "Name cannot exceed 50 characters"),
  date_of_birth: z
    .union([z.date(), z.null()])  // Allow null values
    .refine(
      (date) => date !== null,    // Check for null and provide custom error message
      { message: "Date of Birth is required" }
    )
    .refine(
      (date) => date === null || date <= new Date(),
      { message: "Date of Birth cannot be in the future" }
    ),
  gender: z.string().min(1, "Gender is required"),
  class: z
    .string()
    .min(1, "Class is required")
    .max(20, "Class cannot exceed 20 characters"),
  school: z
    .string()
    .min(1, "School name is required")
    .max(100, "School name cannot exceed 100 characters"),
});

export default addChildrenSchema;
